type Dictionary = Record<string, string>;

export const getLowercaseTabs = (obj: Dictionary | undefined | null): Dictionary => {
  if (!obj) return {};

  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      if (typeof value === 'string') {
        return [key, value.toLowerCase()]
      }
      return [key, value]
    })
  );
}type Dictionary = Record<string, string>;

export const getLowercaseTabs = (obj: Dictionary | undefined | null): Dictionary => {
  if (!obj) return {};

  return Object.fromEntries(
    Object.entries(obj).map(([key, value]) => {
      if (typeof value === 'string') {
        return [key, value.toLowerCase()]
      }
      return [key, value]
    })
  );
}